// Binding legal texts released by VISIBILIS. Stays empty until a released version is stored in this project.
export const LEGAL_DOCS = {
  nutzungsregeln: { title: "Nutzungsregeln", version: null, publishedAt: null, body: null },
  datenschutz: { title: "Datenschutzhinweise", version: null, publishedAt: null, body: null },
};

export const REQUIRED_FOR_REGISTRATION = ["nutzungsregeln", "datenschutz"];

export const isReleased = (doc) =>
  !!(doc && typeof doc.version === "string" && doc.version.trim() && typeof doc.publishedAt === "string" && doc.publishedAt.trim() && typeof doc.body === "string" && doc.body.trim());

// Registration opens only when every required text is released; consent carries the released versions.
export function registrationGate(docs = LEGAL_DOCS) {
  const missing = REQUIRED_FOR_REGISTRATION.filter((k) => !isReleased(docs[k]));
  return {
    open: missing.length === 0,
    missing,
    consent: missing.length ? null : REQUIRED_FOR_REGISTRATION.map((k) => ({ doc: k, version: docs[k].version })),
  };
}
